import { Stack } from '@mui/material';
import Typography from '../../../../../../../../components/Typography';
import useFooter from './vm';
import { i18nNS } from '../../../../../../../../i18n';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation([i18nNS.POLL]);
  const { joinCourseMessage } = useFooter();

  return (
    <Stack gap={2}>
      <Typography variant="paragraphBold" color="error.500">
        {t('if_you_don_t_have_an_acadly_account_yet', { ns: i18nNS.POLL })}
      </Typography>
      <Typography variant="paragraphMedium" color="common.black">
        {joinCourseMessage}
      </Typography>
    </Stack>
  );
};

export default Footer;
